import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    minHeight: '100%',
    alignSelf: 'center',
  },
});

export default useStyles;
